<template>
  <div>
    <v-dialog
      v-model="dialogShow"
      :max-width="formDialogOptions.width"
      :style="{ zIndex: formDialogOptions.zIndex }"
      @keydown.esc.prevent="closeForm"
      persistent
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :hide-overlay="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-form v-model="valid" ref="form">
          <v-toolbar dark color="brown" class="color-gradient-1" dense>
            <v-btn icon dark @click="closeForm">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>{{ title }}</v-toolbar-title>

            <span class="ml-2 mr-2 font-weight-medium grey--text"> | </span>
            <span v-if="formMode === 'EDIT_FORM'">EDIT </span>
            <span class="font-weight-light ml-1 mr-1">ITEM</span>
            <span v-if="formMode === 'NEW_FORM'"> BARU</span>

            <span
              class="ml-2 mr-2 font-weight-medium grey--text"
              v-show="isItemModified"
            >
              |
            </span>
            <v-chip
              class="ma-2"
              color="warning"
              outlined
              x-small
              v-show="isItemModified"
            >
              <v-icon left> mdi-pencil </v-icon>
              modfied
            </v-chip>

            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="save"
                :disabled="!valid || isItemModified === false"
                class="hidden-md-and-up"
              >
                Simpan
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="8" md="8">
                  <v-autocomplete
                    label="Nama Material"
                    v-model="itemFKegiatanMaterial.fmaterialBean"
                    :items="itemsFMaterial"
                    item-value="id"
                    item-text="pname"
                    auto-select-first
                    dense
                    small-chips
                    deletable-chips
                    color="blue-grey lighten-2"
                    persistent-hint
                    :hint="`Kode: ${
                      lookupFMaterial(itemFKegiatanMaterial.fmaterialBean).pcode
                    } & Satuan: ${
                      lookupFMaterial(itemFKegiatanMaterial.fmaterialBean).uom4
                    }`"
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="itemFKegiatanMaterial.price"
                    label="Harga"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="itemFKegiatanMaterial.qty"
                    label="Quantitas"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="itemFKegiatanMaterial.tahun"
                    label="Tahun Perolehan"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="blue lighten-4 rounded-lg" v-if="false">
                <v-col cols="12" sm="3" md="3">
                  <v-text-field
                    v-model="itemFKegiatanMaterial.jumlah"
                    label="Jumlah Item"
                    outlined
                    dense
                    hide-details
                    align="center"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="blue lighten-4 rounded-lg" v-if="penyerahan">
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    v-model="itemFKegiatanMaterial.nilai"
                    label="Nilai"
                    outlined
                    dense
                    prefix="Rp"
                    hide-details
                    align="center"
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-chip
              class="ml-4"
              color="error"
              outlined
              close
              small
              v-show="formDialogOptions.errorMessage"
            >
              {{ formDialogOptions.errorMessage }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="closeForm"
              class="hidden-sm-and-down"
            >
              Batal
            </v-btn>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="save"
              :disabled="!valid || isItemModified === false"
              class="hidden-sm-and-down mr-5"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>

      <CloseConfirmDialog
        ref="refCloseConfirmDialog"
        @eventFromCloseConfirm="passingEventFromCloseConfirm"
      ></CloseConfirmDialog>

      <v-snackbar v-model="snackbar">
        {{ snackBarMesage }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </div>
</template>

<script>
import FKegiatanMaterialService from "@/services/apiservices/f-kegiatan-material-service";

import CloseConfirmDialog from "@/components/utils/CloseConfirmDialog";
import FormMode from "@/models/form-mode";

export default {
  components: { CloseConfirmDialog },
  props: {
    formMode: String,
    penyerahan: String,
  },
  data() {
    return {
      title: "BAHAN METERIAL",
      snackBarMesage: "",
      snackbar: false,

      imageOverlay: false,

      dialogShow: false,
      formDialogOptions: {
        title1: "",
        title2: "",
        message1: "",
        message2: "",
        errorMessage: "",
        color: "grey lighten-3",
        width: 800,
        zIndex: 200,
        noconfirm: false,
      },

      selectedItemIndex: -1,
      itemsFDivision: [],

      valid: false,

      transparent: "rgba(255, 255, 255, 0)",
      rulesNotEmtpy: [(v) => !!v || "Tidak boleh kosong"],
    };
  },
  computed: {
    isItemModified() {
      const defaultItem = JSON.stringify(this.itemDefault);
      const modifiedItem = JSON.stringify(this.itemFKegiatanMaterial);
      return defaultItem !== modifiedItem;
    },
    itemModified: {
      get() {
        return this.$store.state.kegiatan.itemModified;
      },
      set(value) {
        this.$store.dispatch("kegiatan/updateItemModified", value);
      },
    },

    itemFKegiatanMaterial: {
      get() {
        return this.$store.state.kegiatan.itemFKegiatanMaterial;
      },
      set(value) {
        this.$store.dispatch("kegiatan/updateItemFKegiatanMaterial", value);
      },
    },

    itemsFMaterial() {
      return this.$store.state.kegiatan.itemsFMaterial;
    },
    itemsFSatuan() {
      return this.$store.state.kegiatan.itemsFSatuan;
    },
  },
  watch: {},

  methods: {
    showDialog(selectedIndex) {
      this.dialogShow = !this.dialogShow;
      if (selectedIndex > -1) {
        this.selectedIndex = selectedIndex;
        this.initializeEditMode(this.itemFKegiatanMaterial);
      } else {
        this.selectedIndex = -1;
      }
    },

    setDialogState(value) {
      this.dialogShow = value;
    },
    save() {
      if (this.isItemModified === false) {
        //Close aja
        this.dialogShow = false;
        this.$emit("eventFromFormDialog1", this.itemModified);
        return;
      }
      if (this.$refs.form.validate()) {
        // console.log(`helo bos ${this.itemModified.id}`)

        this.itemFKegiatanMaterial.fkegiatanBean = this.itemModified.id;

        if (this.formMode === FormMode.EDIT_FORM) {
          FKegiatanMaterialService.updateFKegiatanMaterial(
            this.itemFKegiatanMaterial
          ).then(
            () => {
              // console.log(response.data)
              this.$emit("eventFromFormDialogEdit", this.itemFKegiatanMaterial);
            },
            (error) => {
              // console.log(error);
              this.formDialogOptions.errorMessage = error.response.data.message;
            }
          );
        } else {
          FKegiatanMaterialService.createFKegiatanMaterial(
            this.itemFKegiatanMaterial
          ).then(
            (response) => {
              this.$emit("eventFromFormDialogNew", response.data);
            },
            (error) => {
              this.formDialogOptions.errorMessage = error.response.data.message;
            }
          );
        }
      }
    },

    closeForm() {
      if (!this.isItemModified) {
        this.dialogShow = false;
        this.$emit("eventFromFormDialog1", this.itemModified);
      } else {
        this.$refs.refCloseConfirmDialog.showDialog(
          " Sudah terdapat modifikasi data",
          "Tetap tutup dan reset perubahan?"
        );
      }
    },
    passingEventFromCloseConfirm(value) {
      if (value === "OKE") this.dialogShow = false;
    },
    initializeEditMode(item) {
      this.formDialogOptions.errorMessage = "";

      FKegiatanMaterialService.getFKegiatanMaterialById(item.id).then(
        (response) => {
          this.itemDefault = Object.assign({}, response.data);
          this.itemFKegiatanMaterial = response.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    lookupFDivision(fdivisionBean) {
      const str = this.itemsFDivision.filter((x) => x.id === fdivisionBean);
      if (str.length > 0) {
        return `${str[0].description} (${str[0].kode1})`;
      } else {
        return "-";
      }
    },
    lookupFMaterial(fmaterialBean) {
      const str = this.itemsFMaterial.filter((x) => x.id === fmaterialBean);
      if (str.length > 0) {
        return str[0];
      } else {
        return "-";
      }
    },
  },
};
</script>

<style scoped>
</style>